import { useState, useEffect } from 'react'

export const useFetchCategories = ({ marvarApi, dispatch, onLogout }) => {

    const [ dataCategories, setDataCategories ] = useState([])

    const [ loadingFetchCategories, setLoadingFetchCategories ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataCategories([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/cash-movement/categories`)
            console.log('[useFetchData][useFetchCategories] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchCategories(true)
        fetchData()
            .then((resp) => {
                setDataCategories(resp.rows)
                setLoadingFetchCategories(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchCategories(false)
            })
    }, [execute])

    return { dataCategories, loadingFetchCategories, executeFetch, resetFetch }
}

export const useFetchAllTransactionsCashier = ({ marvarApi, dispatch, onLogout }) => {
    const defaultParams = {
        startDate: '',
        endDate: '',
        idcaja: '',            // '' = todas
        movimiento_tipo: ''    // '' o 'ALL' = ambos
    }

    const [ paramsToSearch, setParamsToSearch ] = useState(defaultParams)

    const [ dataTransactionsCashier, setTransactionsCashier ] = useState([])
    const [ summaryTransactionsCashier, setSummaryTransactionsCashier ] = useState(null)

    const [ loadingFetchAllTransactionsCashier, setLoadingFetchTransactionsCashier ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => setExecute(!execute)

    const resetFetch = async () => {
        setParamsToSearch(defaultParams)
        setTransactionsCashier([])
        setSummaryTransactionsCashier(null)
    }

    const fetchData = async () => {
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        const _dataBody = {
            startDate: paramsToSearch.startDate,
            endDate: paramsToSearch.endDate,
            idcaja: paramsToSearch.idcaja,
            movimiento_tipo: paramsToSearch.movimiento_tipo
        }

        const response = await marvarApi.post(`/cash-movement/get-cash-movement-by-date`, _dataBody)
        console.log('[useFetchData][useFetchAllTransactionsCashier] response.data ::: ', response.data)
        return response.data
    }

    useEffect(() => {
        if (!paramsToSearch.startDate || !paramsToSearch.endDate) return

        setLoadingFetchTransactionsCashier(true)

        fetchData()
            .then((resp) => {
                setTransactionsCashier(resp?.rows || [])
                setSummaryTransactionsCashier(resp?.summary || null)
                setLoadingFetchTransactionsCashier(false)
            })
            .catch((e) => {
                console.log(e, '________ERROR')
                setLoadingFetchTransactionsCashier(false)
            })
    }, [execute])

    return {
        dataTransactionsCashier,
        summaryTransactionsCashier,
        loadingFetchAllTransactionsCashier,
        setParamsToSearch,
        executeFetch,
        resetFetch
    }
}

export const useFetchSpecificTransactionCashier = ({ marvarApi, dispatch, onLogout, Forms, Helpers, pdfManager }) => {

    const { FormScreen } = Forms
    const { onResetForm, setFormState } = FormScreen

    const defaultParams = {
        idmovimiento: '',
        printTicketFlag: false
    }
    const defaultBase64 = {
        docName: '',
        docBase64: ''
    }
    const [paramsToSearch, setParamsToSearch] = useState(defaultParams)

    const [loadingFetchSpecificTransactionCashier, setLoadingFetchSpecificTransactionCashier] = useState(false)
    
    const [transactionReceiptBase64, setTransactionReceiptBase64] = useState(defaultBase64)

    const [execute, setExecute] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setParamsToSearch(defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {

            const response = await marvarApi.get(`/cash-movement/get-cash-movement-by-id/${paramsToSearch.idmovimiento}`)
            console.log('[useFetchData][useFetchSpecificTransactionCashier] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (paramsToSearch.idmovimiento > 0) {
            setLoadingFetchSpecificTransactionCashier(true)
            fetchData()
                .then((resp) => {

                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idmovimiento: rows[0].idmovimiento || '',
                        idcaja: rows[0].idcaja || '',
                        idcategoria: rows[0].idcategoria || '',
                        currency_type: rows[0].currency_type || '',
                        movimiento_fecha: rows[0].movimiento_fecha || '',
                        movimiento_usuario: rows[0].movimiento_usuario || '',
                        movimiento_tipo: rows[0].movimiento_tipo || '',
                        movimiento_monto: rows[0].movimiento_monto || '',
                        movimiento_moneda: rows[0].movimiento_moneda || '',
                        movimiento_tipo_cambio: rows[0].movimiento_tipo_cambio || '',
                        movimiento_quetzales: rows[0].movimiento_quetzales || '',
                        movimiento_dolares: rows[0].movimiento_dolares || '',
                        movimiento_observaciones: rows[0].movimiento_observaciones || ''
                    }))

                    if (paramsToSearch?.printTicketFlag === true){
                        console.log('imprimiendo PDF')
                        const base64 = Helpers.drawTransactionReceipt(pdfManager, resp.rows[0])
                        setTransactionReceiptBase64(base64)
                        onResetForm() // si no, se quedan los datos en el form
                    }

                    setLoadingFetchSpecificTransactionCashier(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificTransactionCashier(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificTransactionCashier, transactionReceiptBase64, setParamsToSearch, executeFetch, resetFetch }

}

export const useFetchAllCashRegisters = ({ marvarApi, dispatch, onLogout }) => {

    const [cashRegisters, setCashRegisters] = useState([])

    const [loadingFetchCashRegisters, setLoadingFetchCashRegisters] = useState(false)

    const [execute, setExecute] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setCashRegisters([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/cash-movement/fetch-all-cash-registers`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchCashRegisters(true)
        fetchData()
            .then((resp) => {
                setCashRegisters(resp.rows)
                setLoadingFetchCashRegisters(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchCashRegisters(false)
            })
    }, [execute])

    return { cashRegisters, loadingFetchCashRegisters, executeFetch, resetFetch }
}

export const useFetchTransactionsReport = ({ marvarApi, dispatch, onLogout }) => {
    const defaultParams = {
        startDate: '',
        endDate: '',
        idcaja: '',
        movimiento_tipo: 'ALL'
    }

    const [paramsToSearch, setParamsToSearch] = useState(defaultParams)
    const [dataPdfTransactionsReport, setDataPdfTransactionsReport] = useState('')

    const [loadingFetchAllTransactionsReport, setLoadingFetchTransactionsReport] = useState(false)

    const [execute, setExecute] = useState(false)
    const executeFetch = async () => setExecute(!execute)

    const resetFetch = async () => {
        setParamsToSearch(defaultParams)
        setDataPdfTransactionsReport('')
    }

    const fetchData = async () => {
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        const _dataBody = {
            startDate: paramsToSearch.startDate,
            endDate: paramsToSearch.endDate,
            idcaja: paramsToSearch.idcaja,
            movimiento_tipo: paramsToSearch.movimiento_tipo
        }

        const response = await marvarApi.post(`/cash-movement/fetch-transactions-report`, _dataBody, {
            responseType: 'blob'
        })
        console.log('[useFetchData][useFetchTransactionsReport] response.data ::: ', response.data)
        return response.data
    }

    useEffect(() => {
        if (!paramsToSearch.startDate || !paramsToSearch.endDate ) return

        setDataPdfTransactionsReport('')
        setLoadingFetchTransactionsReport(true)

        fetchData()
            .then(async (resp) => {
                if (resp?.type.includes('application/pdf')) {
                    setDataPdfTransactionsReport(URL.createObjectURL(resp))
                } else if (resp?.type.includes('application/json')) {
                    const data = JSON.parse(await resp.text())
                    setDataPdfTransactionsReport(data)
                }

                setLoadingFetchTransactionsReport(false)
            })
            .catch((e) => {
                console.log(e, '________ERROR')
                setDataPdfTransactionsReport('')
                setLoadingFetchTransactionsReport(false)
            })
    }, [execute])

    useEffect(() => {
        return () => {
            if (typeof dataPdfTransactionsReport === 'string' && dataPdfTransactionsReport) {
                URL.revokeObjectURL(dataPdfTransactionsReport)
            }
        }
    }, [dataPdfTransactionsReport])

    return { dataPdfTransactionsReport, loadingFetchAllTransactionsReport, setParamsToSearch, executeFetch, resetFetch }
}

export const useFetchCashierByCategory = ({ marvarApi, dispatch, onLogout }) => {

    const _defaultParams = {
        idcategoria: '',
        currency_type: '',
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataCashRegisters, setDataCashRegisters ] = useState([])

    const [ loadingFetchCashRegisters, setLoadingFetchCashRegisters ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataCashRegisters([])
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const _body = {
                idcategoria: parseInt(paramsToSearch.idcategoria, 10),
                currency_type: String(paramsToSearch.currency_type),
            }
            const response = await marvarApi.post(`/caja/fetch-cashier-by-category-currency`, _body)
            // console.log('[useFetchData][useFetchAllCashRegisters] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (
            paramsToSearch.idcategoria > 0 
            && paramsToSearch.idcategoria !== ''
            && paramsToSearch.currency_type !== ''
        ) {
            setLoadingFetchCashRegisters(true)
            fetchData()
                .then((resp) => {
                    setDataCashRegisters(resp.rows)
                    setLoadingFetchCashRegisters(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchCashRegisters(false)
                })
        }
    }, [execute])

    return { dataCashRegisters, loadingFetchCashRegisters, setParamsToSearch, executeFetch, resetFetch }
}